import { render, staticRenderFns } from "./CurrentMembers.vue?vue&type=template&id=157358bc"
import script from "./CurrentMembers.vue?vue&type=script&lang=js"
export * from "./CurrentMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports